module.exports = __webpack_public_path__ + "static/media/alfred_portrait.acc44e7a.jpg";